import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuardService } from '@unico-people/shared/dashboard/data-access-auth';

import { DataAccessModulesGuard } from '@unico-people/shared/dashboard/data-access-modules';
import { DataAccessOrganizationsGuard } from '@unico-people/shared/dashboard/data-access-organizations';

import { DataAccessPermissionsGuard } from '@unico-people/shared/dashboard/data-access-permissions';

import { FeatureCallbackComponent } from '@unico-people/shared/dashboard/feature-callback';
import { FeatureContentLayoutComponent } from '@unico-people/shared/dashboard/feature-content-layout';

const appRoutes: Routes = [
  {
    path: 'callback',
    component: FeatureCallbackComponent,
    data: { roles: 'benefits' }
  },
  { path: 'preauthorize', component: FeatureCallbackComponent, data: { roles: 'benefits' } },
  { path: 'preauthorize/eligibility', component: FeatureCallbackComponent, data: { roles: 'eligibility' } },
  { path: 'preauthorize/productivity', component: FeatureCallbackComponent, data: { roles: 'productivity' } },
  {
    path: '',
    component: FeatureContentLayoutComponent,
    canActivate: [AuthGuardService],
    data: { roles: 'benefits' },
    children: [
      {
        path: '',
        redirectTo: 'listing',
        pathMatch: 'full'
      },
      {
        path: 'listing',
        canActivate: [DataAccessOrganizationsGuard, DataAccessPermissionsGuard, DataAccessModulesGuard],
        data: { roles: 'benefits' },
        loadChildren: () => import('@unico-people/benefits').then(m => m.BenefitsListingModule)
      },
      {
        path: 'transport',
        loadChildren: () => import('@unico-people/benefits').then(m => m.BenefitsTransportModule)
      },
      {
        path: 'insurance',
        loadChildren: () => import('@unico-people/benefits').then(m => m.BenefitsInsuranceModule)
      },
      {
        path: 'health',
        loadChildren: () => import('@unico-people/benefits').then(m => m.BenefitsHealthModule)
      },
      {
        path: 'food-basket',
        loadChildren: () => import('@unico-people/benefits').then(m => m.BenefitsFoodBasketModule)
      },
      {
        path: 'food',
        loadChildren: () => import('@unico-people/benefits').then(m => m.BenefitsFoodModule)
      },
      {
        path: 'dental',
        loadChildren: () => import('@unico-people/benefits').then(m => m.BenefitsDentalModule)
      },
      {
        path: 'unico-skill',
        loadChildren: () => import('@unico-people/benefits').then(m => m.BenefitsSkillModule)
      }
    ]
  },
  {
    path: 'eligibility',
    component: FeatureContentLayoutComponent,
    canActivate: [AuthGuardService],
    data: { roles: 'eligibility' },
    children: [
      {
        path: '',
        redirectTo: 'listing',
        pathMatch: 'full'
      },
      {
        path: 'listing',
        canActivate: [DataAccessOrganizationsGuard, DataAccessPermissionsGuard, DataAccessModulesGuard],
        data: { roles: 'eligibility' },
        loadChildren: () => import('@unico-people/benefits').then(m => m.BenefitsEligibilityModule)
      }
    ]
  },
  {
    path: 'productivity',
    data: { roles: 'productivity' },
    canActivate: [AuthGuardService],
    component: FeatureContentLayoutComponent,
    loadChildren: () => import('@unico-people/benefits').then(m => m.BenefitsProductivityModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule],
  providers: [AuthGuardService, DataAccessOrganizationsGuard, DataAccessPermissionsGuard, DataAccessModulesGuard]
})
export class AppRoutingModule {}
